import { Badge, Typography } from 'antd';
import UserAvatar from '../../../elements/containers/UserAvatarContainer';

const { Text } = Typography;

const SmsConversationItem = ({
  onSelectSmsConversation,
  selectedSmsConversation,
  smsConversation,
  smsConversationName,
  ...props
}) => {
  return (
    <div
      key={smsConversation.id}
      className={`sms-conversation-item ${
        selectedSmsConversation?.id === smsConversation.id ? 'active' : ''
      }`}
      onClick={() => onSelectSmsConversation(smsConversation)}
    >
      <div className='sms-conversation-avatar'>
        <UserAvatar user={smsConversation?.profile} />
      </div>

      <div className='sms-conversation-info'>
        <Text strong className='sms-conversation-name'>
          {smsConversationName(smsConversation)}
        </Text>
        <Text type='secondary' className='sms-conversation-last-message'>
          {smsConversation?.last_sms_message?.body}
        </Text>
      </div>
      <div className='sms-conversation-actions'>
        {smsConversation?.unread_count > 0 && (
          <Badge
            className='sms-conversation-badge-unread-count'
            count={smsConversation.unread_count}
            showZero={false}
          />
        )}
        {/*
        This is commented out for now at the customer's request. If it becomes necessary again, uncomment it.
        <SmsConversationMenuItem smsConversation={smsConversation} /> 
        */}
      </div>
    </div>
  );
};

export default SmsConversationItem;
